import React from 'react';
import ReactDOM from 'react-dom/client';
import '@/styles/index.scss';
import { MsalProvider } from '@azure/msal-react';
import { Provider } from 'react-redux';
import App from 'app/app';
import store from '@/app/store/store';
import reportWebVitals from 'reportWebVitals';
import Hotjar from '@hotjar/browser';
import msalInstance from './app/msal';
import { APIProvider } from '@vis.gl/react-google-maps';
import { FeatureFlagProvider } from './context/featureFlagContext';
import { AutomationProvider } from './context/automationContext';
import { FirebaseTokenProvider } from './context/firebaseTokenContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
const localhost = window.location.hostname === 'localhost';

// Initialise Hotjar for recording
if ((process.env.REACT_APP_HOTJAR_ID ?? '').length > 0 && !localhost) {
	Hotjar.init(process.env.REACT_APP_HOTJAR_ID, 6);
}

root.render(
	<React.StrictMode>
		<MsalProvider instance={msalInstance}>
			<Provider store={store}>
				<FeatureFlagProvider>
					<FirebaseTokenProvider>
						<AutomationProvider>
							<APIProvider
								apiKey={process.env.REACT_APP_GOOGLE_PLACES_KEY}
								solutionChannel='folio'
							>
								<App />
							</APIProvider>
						</AutomationProvider>
					</FirebaseTokenProvider>
				</FeatureFlagProvider>
			</Provider>
		</MsalProvider>
	</React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
